/**
 * Stable CSS class names for E2E — pages/SiteManagement/EditUser.
 * Containers use `edit-user__<element>`; inputs and user-interactable controls
 * use `edit-user-input--<name>`.
 *
 * Note: `SCUIOperatorDialog` and `SCUIOperatorMainRow` are shared atomic
 * molecules, so we only expose page-level hooks here (the dialog is wrapped
 * in a Box that carries a stable container class).
 */
export const EU = {
    page: 'edit-user-page',
    root: 'edit-user',

    operatorDialogWrap: 'edit-user__operator-dialog-wrap',

    /* --- Header / toolbar --------------------------------------------- */
    titleBox: 'edit-user__title-box',
    title: 'edit-user__title',

    backBox: 'edit-user__back-box',
    linkBack: 'edit-user-input--link-back',

    addUserBox: 'edit-user__add-user-box',
    btnAddUser: 'edit-user-input--button-add-user',

    inputSearch: 'edit-user-input--search',

    /* --- Operator table ----------------------------------------------- */
    tablePaper: 'edit-user__table-paper',
    tableContainer: 'edit-user__table-container',
    table: 'edit-user__table',
    tableHead: 'edit-user__table-head',
    tableHeadRow: 'edit-user__table-head-row',
    tableHeadCell: 'edit-user__table-head-cell',
    tableHeadCellUserName: 'edit-user__table-head-cell--user-name',
    tableHeadCellOperatorId: 'edit-user__table-head-cell--operator-id',
    tableHeadCellDomain: 'edit-user__table-head-cell--domain',
    tableHeadCellRemoveUser: 'edit-user__table-head-cell--remove-user',
    tableBody: 'edit-user__table-body',

    /* --- Empty state -------------------------------------------------- */
    emptyPaper: 'edit-user__empty-paper',
    emptyText: 'edit-user__empty-text',
} as const;

export const euCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
